import { action } from 'easy-peasy';
import { ISetMonthlyRecordAction } from '../types';

const setMonthlyRecord: ISetMonthlyRecordAction = action((state, payload) => {
  state.monthlyRecord = payload;
});

export default setMonthlyRecord;
